import React, { useEffect, useState } from 'react'
import {
	Badge,
	BadgeProps,
	Button,
	Calendar,
	CalendarProps,
	Card,
	DatePicker,
	Select,
	Space,
	Table,
} from 'antd'
import useSWR from 'swr'
import { useToken } from '../../hooks'
import API from '../../../utils/api'
import { useExchangeList } from '../../hooks/trade/exchangeList'
import {
	DownloadOutlined,
	OrderedListOutlined,
	ReloadOutlined,
} from '@ant-design/icons'
import AdminUserModal from '../AdminUserModal'
import { goTo } from '../../hooks/navigation'
import { useHistory } from 'react-router'
import BigNumber from 'bignumber.js'

import dayjs, { Dayjs } from 'dayjs'
import KrwPrice from '../PositionColumns/KrwPrice'
import * as XLSX from 'xlsx'
import { View } from '../../../styles/reactnative'
import { useUserGroup } from '../../hooks/user/usergroups'
import { FOOTER } from '../../constants/SETTING'
import DateSearch from './DateSearch'

const TableAPI = ({
	title,
	titletotal = false,
	apikey,
	columns,
	width = '100%',
	stylewidth = '100%',
	height = 470,
	pagination = true,
	usermodal = false,
	detail = '',
	datesearch = false,
	walletlist = false,
	action = () => {},
	actionmodal = () => {},
	defaultMaxData = 20,
	loadingshow = true,
	autorefresh = 0,
	refresh = false,
	footer = 0,
	fold = false,
	sharemutate = '',
	extra = null,
	uid = null,
	groupsearch = false,
	setSC = e => {},
	reloadAction = () => {},
	onrowclickuser = false,
	prevsplit = false,
	calender = false,
	excpetclick = false,
}: any) => {
	const { data: token, level } = useToken()
	const nav = useHistory()

	const [page, setPage] = useState(1)
	const [maxData, setMaxData] = useState(defaultMaxData)
	const [showModal, setShowModal] = useState(false)
	const [selectedData, setSelectedData] = useState<any>(null)
	const [startDate, setStartDate] = useState<any>(null)
	const [endDate, setEndDate] = useState<any>(null)

	const [walletType, setWalletType] = useState<any>(null)

	const [type, setType] = useState(0)

	const [edit, setEdit] = useState<any>(false)

	const { data: EPs } = useExchangeList()
	const [group, setGroup] = useState('')

	const { type1 } = useUserGroup()

	useEffect(() => {

		if(!datesearch) return;

		const now = dayjs()
		setType(0)
		if (now.hour() < 6) {
			setStartDate(now.subtract(8, 'day').format('YYYY-MM-DD 06:00:00'))
			setEndDate(now.format('YYYY-MM-DD 05:59:59'))
		} else {
			setStartDate(now.subtract(7, 'day').format('YYYY-MM-DD 06:00:00'))
			setEndDate(now.add(1, 'day').format('YYYY-MM-DD 05:59:59'))
		}
	}, [])

	let footerTable: any = () => {
		return null
	}
	if (footer == FOOTER.MARGINSUM) {
		footerTable = () => {
			return (
				<View style={{ flexDirection: 'row', gap: 10 }}>
					동결금합 :{' '}
					<KrwPrice
						price={dataSource.reduce(
							(acc, curr) =>
								BigNumber(acc).plus(curr['margin']).toNumber(),
							0
						)}
					/>
				</View>
			)
		}
	} else if (footer == 1) {
		footerTable = () => {
			const groupedData = dataSource.reduce((acc, curr) => {
				const userId = curr['id']
				const existingEntry = acc.find(
					entry => entry['user_id'] === userId
				)

				if (existingEntry) {
					// 이미 그룹이 존재하는 경우
					if (curr['daydate'] > existingEntry['daydate']) {
						// 현재 데이터가 더 최근인 경우 값을 업데이트
						existingEntry['last_balance'] = curr['last_balance']
					}
				} else {
					// 그룹이 존재하지 않는 경우 새로운 그룹 생성
					acc.push({
						user_id: userId,
						last_balance: curr['last_balance'],
						daydate: curr['daydate'], // 최근값 비교를 위한 timestamp 추가
					})
				}

				return acc
			}, [])
			return (
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						flexDirection: 'column',
						alignItems: 'center',
						flex: 1,
						width: '100%',
					}}>
					<div style={{ width: '100%' }}>
						총갯수: {data?.totalCount || 0}
					</div>

					<View style={{ flexDirection: 'row', gap: 10 }}>
						<View>
							<View
								style={{
									whiteSpace: 'nowrap',
									width: '100%',
									flexDirection: 'row',
								}}>
								일반 입금 합계:
								<KrwPrice
									style={{ width: 150 }}
									price={dataSource.reduce(
										(acc, curr) =>
											BigNumber(acc)
												.plus(
													curr['total_deposit_amount']
												)
												.toNumber(),
										0
									)}
								/>
							</View>

							<View
								style={{
									whiteSpace: 'nowrap',
									width: '100%',
									flexDirection: 'row',
								}}>
								별도 입금 합계:
								<KrwPrice
									style={{ width: 150 }}
									price={dataSource.reduce(
										(acc, curr) =>
											BigNumber(acc)
												.plus(
													+curr[
														'total_deposit_amount_extra'
													] || 0
												)
												.toNumber(),
										0
									)}
								/>
							</View>
							<View
								style={{
									whiteSpace: 'nowrap',
									width: '100%',
									flexDirection: 'row',
								}}>
								{'코인>해선 합계:'}
								<KrwPrice
									style={{ width: 150 }}
									price={dataSource.reduce(
										(acc, curr) =>
											BigNumber(acc)
												.plus(
													+curr[
														'total_deposit_amount_move'
													] || 0
												)
												.toNumber(),
										0
									)}
								/>
							</View>
							<View
								style={{
									whiteSpace: 'nowrap',
									width: '100%',
									flexDirection: 'row',
									borderBottom: '1px solid #efefef',
									borderTop: '1px solid #efefef',
								}}>
								{'입금총합 합계:'}
								<KrwPrice
									style={{ width: 150 }}
									price={dataSource.reduce(
										(acc, curr) =>
											BigNumber(acc)
												.plus(
													curr[
														'total_deposit_amount_move'
													]
												)
												.plus(
													curr[
														'total_deposit_amount_extra'
													]
												)
												.plus(
													curr['total_deposit_amount']
												)
												.toNumber(),
										0
									)}
								/>
							</View>
						</View>

						<View>
							<View
								style={{
									whiteSpace: 'nowrap',
									width: '100%',
									flexDirection: 'row',
								}}>
								일반 출금 합계:
								<KrwPrice
									style={{ width: 150 }}
									price={
										-Math.abs(
											dataSource.reduce(
												(acc, curr) =>
													BigNumber(acc)
														.plus(
															+curr[
																'total_withdraw_amount'
															] || 0
														)
														.toNumber(),
												0
											)
										)
									}
								/>
							</View>

							<View
								style={{
									whiteSpace: 'nowrap',
									width: '100%',
									flexDirection: 'row',
								}}>
								별도 출금 합계:
								<KrwPrice
									style={{ width: 150 }}
									price={
										-Math.abs(
											dataSource.reduce(
												(acc, curr) =>
													BigNumber(acc)
														.plus(
															curr[
																'total_withdraw_amount_extra'
															]
														)
														.toNumber(),
												0
											)
										)
									}
								/>
							</View>
							<View
								style={{
									whiteSpace: 'nowrap',
									width: '100%',
									flexDirection: 'row',
								}}>
								{'해선>코인 합계:'}
								<KrwPrice
									style={{ width: 150 }}
									price={
										-Math.abs(
											dataSource.reduce(
												(acc, curr) =>
													BigNumber(acc)
														.plus(
															curr[
																'total_withdraw_amount_move'
															]
														)
														.toNumber(),
												0
											)
										)
									}
								/>
							</View>
							<View
								style={{
									whiteSpace: 'nowrap',
									width: '100%',
									flexDirection: 'row',
									borderBottom: '1px solid #efefef',
									borderTop: '1px solid #efefef',
								}}>
								{'출금총합 합계:'}
								<KrwPrice
									style={{ width: 150 }}
									price={
										-Math.abs(
											dataSource.reduce(
												(acc, curr) =>
													BigNumber(acc)
														.plus(
															curr[
																'total_withdraw_amount_move'
															]
														)
														.plus(
															curr[
																'total_withdraw_amount_extra'
															]
														)
														.plus(
															curr[
																'total_withdraw_amount'
															]
														)
														.toNumber(),
												0
											)
										)
									}
								/>
							</View>
						</View>

						<View
							style={{
								borderLeft: '1px solid #ccc',
								paddingLeft: 10,
							}}>
							<View
								style={{
									whiteSpace: 'nowrap',
									width: '100%',
									flexDirection: 'row',
								}}>
								총매매손익 합:
								<KrwPrice
									style={{ width: 150 }}
									price={dataSource.reduce(
										(acc, curr) =>
											BigNumber(acc)
												.plus(
													curr['total_pnl_price'] || 0
												)
												.toNumber(),
										0
									)}
								/>
							</View>
							<View
								style={{
									whiteSpace: 'nowrap',
									width: '100%',
									flexDirection: 'row',
								}}>
								총수수료 합계:
								<KrwPrice
									style={{ width: 150 }}
									price={dataSource.reduce(
										(acc, curr) =>
											BigNumber(acc)
												.plus(
													-Math.abs(
														curr['total_fee_price']
													) || 0
												)
												.toNumber(),
										0
									)}
								/>
							</View>
							<View
								style={{
									whiteSpace: 'nowrap',
									width: '100%',
									flexDirection: 'row',
								}}>
								실현손익 합계:
								<KrwPrice
									style={{ width: 150 }}
									price={dataSource.reduce(
										(acc, curr) =>
											BigNumber(acc)
												.plus(
													curr['total_trade_price'] ||
														0
												)
												.toNumber(),
										0
									)}
								/>
							</View>
							<View
								style={{
									whiteSpace: 'nowrap',
									width: '100%',
									flexDirection: 'row',
								}}>
								마지막잔액 합:
								<KrwPrice
									style={{ width: 150 }}
									price={groupedData.reduce(
										(acc, curr) =>
											BigNumber(acc)
												.plus(curr['last_balance'] || 0)
												.toNumber(),
										0
									)}
								/>
							</View>
						</View>
					</View>
				</div>
			)
		}
	} else if (footer == 2) {
		footerTable = () => {
			return (
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						flex: 1,
						width: '100%',
					}}>
					<div style={{ width: 60 }}>
						Total: {data?.totalCount || 0}
					</div>

					{fold && (
						<>
							<KrwPrice
								style={{ width: 130 }}
								price={dataSource.reduce(
									(acc, curr) =>
										BigNumber(acc)
											.plus(curr['total_deposit_amount'])
											.toNumber(),
									0
								)}
							/>
							<KrwPrice
								style={{ width: 130 }}
								price={dataSource.reduce(
									(acc, curr) =>
										BigNumber(acc)
											.plus(curr['total_withdraw_amount'])
											.toNumber(),
									0
								)}
							/>
						</>
					)}
					<KrwPrice
						style={{ width: 130 }}
						price={dataSource.reduce(
							(acc, curr) =>
								BigNumber(acc)
									.plus(curr['total_pnl_price'] || 0)
									.toNumber(),
							0
						)}
					/>
					<KrwPrice
						style={{ width: 130 }}
						price={dataSource.reduce(
							(acc, curr) =>
								BigNumber(acc)
									.plus(
										-Math.abs(curr['total_fee_price']) || 0
									)
									.toNumber(),
							0
						)}
					/>
					<KrwPrice
						style={{ width: 150 }}
						price={dataSource.reduce(
							(acc, curr) =>
								BigNumber(acc)
									.plus(curr['total_trade_price'] || 0)
									.toNumber(),
							0
						)}
					/>

					<KrwPrice
						style={{ width: 130 }}
						price={dataSource.reduce(
							(acc, curr) =>
								BigNumber(acc)
									.plus(curr['last_sumbalance'] || 0)
									.toNumber(),
							0
						)}
					/>
				</div>
			)
		}
	} else if (footer == 3) {
		footerTable = () => {
			return (
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						flex: 1,
						width: '100%',
					}}>
					<div style={{ width: 60 }}>
						Total: {data?.totalCount || 0}
					</div>
					<div style={{ width: 480 }}></div>

					<KrwPrice
						style={{ width: 200 }}
						price={dataSource.reduce(
							(acc, curr) =>
								BigNumber(acc)
									.plus(curr['amount'] || 0)
									.toNumber(),
							0
						)}
					/>

					<KrwPrice
						style={{ width: 180 }}
						price={dataSource.reduce(
							(acc, curr) =>
								BigNumber(acc)
									.plus(curr['confirm_amount'] || 0)
									.toNumber(),
							0
						)}
					/>
					<div style={{ flex: 1 }}></div>
				</div>
			)
		}
	}
	const dateurl = `${(startDate && `&startdate=${startDate}`) || ''}
	${(endDate && `&enddate=${endDate}`) || ''}`

	const groupurl = `${(group && `&group=${group}`) || ''}`

	let KEY = apikey
		? apikey +
		  dateurl +
		  '&maxData=' +
		  maxData +
		  '&page=' +
		  page +
		  (walletType ? `&type=detail&searchWord=${walletType}` : '') +
		  groupurl
		: null

	let SHAREKEY = sharemutate
		? sharemutate +
		  dateurl +
		  '&maxData=' +
		  maxData +
		  '&page=' +
		  page +
		  (walletType ? `&type=detail&searchWord=${walletType}` : '') +
		  groupurl
		: null

	const { data, mutate, isLoading, isValidating } = useSWR<any>(
		KEY,
		async () => {
			const response = await API.get(`${KEY}`, token + '', {})
			console.log('Table API', response)
			return response?.result?.result
		},
		autorefresh
			? {
					revalidateOnFocus: false,
					dedupingInterval: 0,
					refreshInterval: autorefresh,
			  }
			: { revalidateOnFocus: false, dedupingInterval: 0 }
	)
	const { mutate: shareMutate } = useSWR<any>(
		SHAREKEY,
		async () => {
			const response = await API.get(`${SHAREKEY}`, token + '', {})
			console.log('Table API', response)
			return response?.result?.result
		},
		autorefresh
			? {
					revalidateOnFocus: false,
					dedupingInterval: 0,
					refreshInterval: autorefresh,
			  }
			: { revalidateOnFocus: false, dedupingInterval: 0 }
	)

	useEffect(() => {
		KEY = apikey
			? apikey +
			  dateurl +
			  '&maxData=' +
			  maxData +
			  '&page=' +
			  page +
			  groupurl
			: null

		SHAREKEY = sharemutate
			? sharemutate +
			  dateurl +
			  '&maxData=' +
			  maxData +
			  '&page=' +
			  page +
			  groupurl
			: null
	}, [page])

	useEffect(() => {
		setPage(1)
	}, [dateurl, maxData, apikey])

	const dataSource = data?.list || []

	dataSource?.map((item, index) => {
		item.pairsinfo = EPs?.filter(
			EP => item?.exchange_pairs_id === EP?.id
		)[0]

		return item
	})

	const exceldata = dataSource?.map(item => {
		//total_withdraw_amount 은 마이너스로 표기
		item.total_deposit_amount = +item.total_deposit_amount
		item.total_withdraw_amount = -1 * item.total_withdraw_amount
		item.total_withdraw_amount_extra = -1 * item.total_withdraw_amount_extra
		item.total_withdraw_amount_move = -1 * item.total_withdraw_amount_move

		item.total_withdraw_confirm_amount =
			-1 * item.total_withdraw_confirm_amount

		item.total_fee_price = -1 * item.total_fee_price || 0

		return item
	})

	const exportToExcel = () => {
		if (!exceldata?.length) return;

		try {
			// 엑셀 데이터 준비
			const exportData = exceldata.map(item => {
				const row = {};
				columns(
					mutate,
					data => {
						setSelectedData(data)
						setShowModal(true)
					},
					token,
					fold,
					edit,
					setEdit,
					shareMutate,
					uid,
					setSC,
					level
				).forEach(col => {
					if (col?.dataIndex) {
						if (col.dataIndex === 'user_id' || col.title === '회원') {
							row['회원코드'] = item[col.dataIndex];
							row['실명'] = item['fullname'];
							row['회원메일'] = item['email'];
							row['회원연락'] = item['phone'];
						} else {
							row[col.title || col.dataIndex] = item[col.dataIndex];
						}
					}
					col?.children?.forEach(child => {
						if (child?.dataIndex) {
							row[child.title || child.dataIndex] = item[child.dataIndex];
						}
					});
				});
				return row;
			});

			// 워크북 생성
			const wb = XLSX.utils.book_new();
			const ws = XLSX.utils.json_to_sheet(exportData);
			XLSX.utils.book_append_sheet(wb, ws, 'excel');
			
			// 파일명 생성 및 저장
			const fileName = `${((title && (title + '')?.replace(/\//gi, '')) || 'Export')}${new Date().getTime()}.xlsx`;
			XLSX.writeFile(wb, fileName);
		} catch (error) {
			console.error('Excel export error:', error);
		}
	};

	const dateCellRender = (value: Dayjs) => {
		//{ type: 'warning', content: 'This is warning event.' }
		//startdate , enddate, enddate 하루전까지만 표기
		const data =
			dataSource.filter(item => {
				const startdate = dayjs(item.startdate)
				const enddate = dayjs(item.enddate)

				return (
					value.isSame(startdate, 'day') ||
					value.isSame(enddate, 'day') ||
					value.isSame(enddate.subtract(1, 'day'), 'day')
				)
			}) || []

		const listData = data.map(item => {
			const startdate = dayjs(item.startdate)
			const enddate = dayjs(item.enddate)

			if (value.isSame(startdate, 'day'))
				return { type: 'success', content: item.pairs }
			if (value.isSame(enddate, 'day'))
				return { type: 'error', content: item.pairs }

			return { type: 'warning', content: item.pairs }
		})

		return (
			<ul
				className="events"
				style={
					listData?.length
						? {
								position: 'static',
								margin: 0,
								listStyle: 'none',
								gap: 5,
								backgroundColor: '#f1f1f1',
								padding: 10,
								zIndex: 0,
								borderRadius: 5,
						  }
						: {
								display: 'none',
						  }
				}>
				{listData.map(item => (
					<Badge
						status={item.type as BadgeProps['status']}
						style={{ marginLeft: 5, marginRight: 5 }}
						text={item.content}
					/>
				))}
			</ul>
		)
	}

	const cellRender: CalendarProps<Dayjs>['cellRender'] = (current, info) => {
		if (info.type === 'date') return dateCellRender(current)
		return info.originNode
	}

	return (
		<>
			{calender && (
				<Calendar fullscreen={false} cellRender={cellRender} />
			)}
			<Card
				key={'card' + KEY}
				title={`${title ? title : ''}${
					titletotal ? ' (' + dataSource?.length + ')' : ''
				}`}
				extra={
					<Space size="small">
						{extra}

						{walletlist && (
							<Space.Compact size="small">
								<Button
									size="small"
									onClick={() => setWalletType('')}
									type={
										walletType == '' ? 'primary' : 'ghost'
									}>
									전체
								</Button>
								<Button
									size="small"
									onClick={() =>
										setWalletType('ADMINDEPOSIT')
									}
									type={
										walletType == 'ADMINDEPOSIT'
											? 'primary'
											: 'ghost'
									}>
									별도입금
								</Button>
								<Button
									size="small"
									onClick={() =>
										setWalletType('ADMINWITHDRAW')
									}
									type={
										walletType == 'ADMINWITHDRAW'
											? 'primary'
											: 'ghost'
									}>
									별도출금
								</Button>
								<Button
									size="small"
									onClick={() => setWalletType('CASHDEPOSIT')}
									type={
										walletType == 'CASHDEPOSIT'
											? 'primary'
											: 'ghost'
									}>
									현금입출
								</Button>
							</Space.Compact>
						)}
						{groupsearch && (
							<Select
								defaultValue={'*'}
								onChange={e => {
									setGroup(e)
								}}
								value={group}
								style={{ width: '100%', minWidth: 150 }}
								options={[
									{ value: '', label: '그룹전체' },
									...(type1 || []),
								]}
							/>
						)}

						{datesearch && (
							<DateSearch
								type={type}
								setType={setType}
								startDate={startDate}
								setStartDate={setStartDate}
								endDate={endDate}
								setEndDate={setEndDate}
							/>
						)}

						{detail && (
							<Button
								onClick={() => {
									goTo(nav, detail)
								}}
								type="ghost"
								size="small">
								<OrderedListOutlined />
							</Button>
						)}

						<Button
							icon={<DownloadOutlined />}
							type="ghost"
							onClick={exportToExcel}
						/>

						<Button
							onClick={() => {
								mutate(1)
								reloadAction()
							}}
							type="ghost"
							size="small">
							<ReloadOutlined />
						</Button>

						{action && action(mutate)}
						{actionmodal && actionmodal(mutate)}
					</Space>
				}
				size="small"
				style={{
					width: stylewidth ? stylewidth : '100%',
					height: '100%',
					margin: 0,
					padding: 0,
				}}>
				<Table
					key={'table' + KEY}
					loading={loadingshow && (isLoading || isValidating)}
					bordered
					onRow={(record, rowIndex) => {
						return {
							onClick: e => {
								if (
									(e?.nativeEvent?.target as any)
										?.innerText == '세션아웃'
								)
									return

								if (onrowclickuser) {
									setSelectedData(record?.id)
									setShowModal(true)
								}
							},
						}
					}}
					rowKey={(record: any, index: any) =>
						'ROW' +
						record?.id +
						'_' +
						index +
						'_' +
						record?.fullname
					}
					pagination={
						pagination
							? {
									current: page,
									total: data?.totalCount || 1,
									pageSize: maxData,
									showSizeChanger: true,
									showQuickJumper: true,
									pageSizeOptions: [
										'20',
										'50',
										'100',
										'200',
										'500',
										'1000',
										'10000',
									],
									onShowSizeChange: (current, size) => {
										setMaxData(size)
										setPage(1)
									},
									onChange: page => setPage(page),
							  }
							: false
					}
					footer={footerTable}
					dataSource={dataSource}
					rowClassName={(record, index) => {
						let prevclass = ''
						let dateclass = ''

						if (record?.startdate || record?.enddate) {
							const now = new Date()
							const startdate = new Date(record?.startdate)
							const enddate = new Date(record?.enddate)

							if (now < startdate) {
								dateclass = 'future-row'
							} else if (now >= enddate) {
								dateclass = 'expired-row'
							}

							//enddate 2일전, 이미 지난건 제외
							const enddate2 = new Date(record?.enddate)
							enddate2.setDate(enddate2.getDate() - 2)
							if (now > enddate2 && now < enddate) {
								dateclass = 'warn'
							}
						}

						if (prevsplit) {
							const previd = dataSource[index - 1]?.id
							const nextid = record?.id

							if (previd && nextid && previd != nextid) {
								prevclass = 'split-row'
							}
						}

						if (record?.sub_group) {
							return (
								'parent-row sub-group ' +
								prevclass +
								' ' +
								dateclass
							)
						}

						if (record?.parentid) {
							return 'child-row ' + prevclass + ' ' + dateclass
						} else {
							return 'parent-row ' + prevclass + ' ' + dateclass
						}

						if (record?.warn) {
							console.log('record', record?.warn)
						}
						if (record['warn']) {
							return 'warn'
						} else {
							return ''
						}
					}}
					columns={columns(
						mutate,
						data => {
							setSelectedData(data)
							setShowModal(true)
						},
						token,
						fold,
						edit,
						setEdit,
						shareMutate,
						uid,
						setSC,
						level
					)}
					scroll={
						!height || height == 'default'
							? { x: width }
							: { x: width, y: height }
					}
					size="small"
					style={{
						width: stylewidth ? stylewidth : '100%',
						padding: 0,
						margin: 0,
					}}
				/>
				{usermodal && (
					<AdminUserModal
						showModal={showModal}
						setShowModal={setShowModal}
						selectedData={selectedData}
					/>
				)}
			</Card>
		</>
	)
}

export default React.memo(TableAPI)
